/** Typed failures from the Simkl API. Callers branch on these, never on status codes. */

export class SimklError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly path: string,
  ) {
    super(message);
    this.name = "SimklError";
  }
}

/**
 * The token is dead and no retry will help.
 *
 * Simkl tokens last years and have no refresh endpoint, so a 401 always means
 * "sign in again" — never a transient failure to back off from.
 */
export class AuthExpiredError extends SimklError {
  constructor(path: string) {
    super("Simkl rejected the token; sign in again", 401, path);
    this.name = "AuthExpiredError";
  }
}

/** Simkl asked us to slow down. */
export class RateLimitedError extends SimklError {
  constructor(path: string) {
    super("Simkl rate limit reached", 429, path);
    this.name = "RateLimitedError";
  }
}

/** The response did not match the shape the app relies on. */
export class SchemaError extends Error {
  constructor(
    readonly path: string,
    readonly detail: string,
  ) {
    super(`Unexpected response shape from ${path}: ${detail}`);
    this.name = "SchemaError";
  }
}

/** The request never reached Simkl — offline, DNS, or a blocked origin. */
export class NetworkError extends Error {
  constructor(
    readonly path: string,
    override readonly cause: unknown,
  ) {
    super(`Could not reach Simkl at ${path}`);
    this.name = "NetworkError";
  }
}
